// share-table-report"
import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    tableId = '0',
    password = '',
    inputName = '',
    expired = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utableData.shareTableForm, {
        tableId: Number.parseInt(tableId, 10) || 0,
        password,
        inputName,
        expired,
    }, options);
    if (error) return { error, status };
    return content || {};
};
